"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImagePlaceholder = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _common = require("../../common");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ImagePlaceholder = ({
  height,
  isLoadingPlaceholder,
  isSquare,
  testId,
  width,
  ...htmlDivElementProps
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    ...htmlDivElementProps,
    height: height,
    isSquare: isSquare,
    width: width,
    "data-testid": testId ?? getTestId(_common.IMAGE_PLACEHOLDER),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Products, {
      fontSize: "inherit"
    }), isLoadingPlaceholder ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Background, {
      animation: "wave",
      height: "100%",
      variant: "rectangular",
      width: "100%",
      "data-testid": getTestId(_common.IMAGE_PLACEHOLDER_BACKGROUND)
    }) : null]
  });
};
exports.ImagePlaceholder = ImagePlaceholder;
